import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { HeaderErrorEnum } from '../enums/header-error.enum';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { ILoginIn } from '../interfaces/auth.interface';
import { IUser, IUserDTOIn } from '../interfaces/users/user.interface';
import { MappersService } from './mappers.service';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {
    constructor(private http: HttpClient, private mapperService: MappersService) {}

    public login(email: string, password: string): Observable<ILoginIn> {
        const headers: HttpHeaders = new HttpHeaders().set(HeaderErrorEnum.OWN_ERROR, 'true');
        return this.http.post<any>(environment.wasoApi + SubUrlsEnum.LOGIN, { email, password }, { headers });
    }

    public logout(): Observable<any> {
        const headers: HttpHeaders = new HttpHeaders().set(HeaderErrorEnum.OWN_ERROR, 'true');
        return this.http.delete<any>(environment.wasoApi + SubUrlsEnum.LOGOUT, { headers });
    }

    public resetPassword(email: string): Observable<any> {
        const headers: HttpHeaders = new HttpHeaders().set(HeaderErrorEnum.OWN_ERROR, 'true');
        return this.http.post<any>(environment.wasoApi + SubUrlsEnum.RECOVERY_PWD, { email }, { headers });
    }

    public setNewPwd(newPassword: string, passwordToken: string): Observable<any> {
        const headers: HttpHeaders = new HttpHeaders().set(HeaderErrorEnum.OWN_ERROR, 'true');
        const params: HttpParams = new HttpParams().set('reset_password_token', passwordToken);
        return this.http.post<any>(environment.wasoApi + SubUrlsEnum.RESET_PWD, { newPassword }, { headers, params });
    }

    public createPwd(password: string, token: string): Observable<any> {
        const headers: HttpHeaders = new HttpHeaders();
        return this.http.post<any>(environment.wasoApi + SubUrlsEnum.CREATE_PWD, { password_token: token, password }, { headers });
    }

    public getMyUser(): Observable<IUser> {
        const headers: HttpHeaders = new HttpHeaders().set(HeaderErrorEnum.OWN_ERROR, 'true');
        return this.http
            .get<IUserDTOIn>(environment.wasoApi + SubUrlsEnum.MYUSER, { headers })
            .pipe(map((user: IUserDTOIn) => this.mapperService.fromIUserDTOInToIUser(user)));
    }

    public refreshTokens(refreshToken: string): Observable<ILoginIn> {
        const headers: HttpHeaders = new HttpHeaders({
            ['Refresh-Token']: refreshToken,
        });
        return this.http.post<ILoginIn>(environment.wasoApi + SubUrlsEnum.REFRESH_TOKEN, null, { headers });
    }
}
